/**
 * <CustomField />
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 * 
 * fields format : [{
 *  id: number,
 *  type: can be either 'text' or 'checkbox' or 'select'
 *  label: string
 *  required: boolen,
 *  options: [string]
 * },]
 */
import React, { PropTypes } from 'react';
import locale from './locale';
import Panel from 'components/UI/Panel';
import Loading from 'components/UI/Loading';
import FieldItem from './FieldItem';
import map from 'lodash/map';
import confirm from 'util/confirm';
import uniqid from 'uniqid';

class CustomField extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onSort = this.onSort.bind(this);
    this.addFieldItem = this.addFieldItem.bind(this);
    this.removeFieldItem = this.removeFieldItem.bind(this);
    this.toggleFieldItemEditor = this.toggleFieldItemEditor.bind(this);

    this.state = {
      toggledEditor: {},
      draggableIndex: -1,
    }
  }

  addFieldItem() {
    const { closeEditorsWhenAddNewItem, updateField } = this.props;
    let fields = this.props.fields;
    let { toggledEditor } = this.state;

    if (closeEditorsWhenAddNewItem) {
      toggledEditor = {};
    }

    toggledEditor[0] = true;

    let newFields = [
      {
        id: uniqid(),
        type: 'text',
        label: '',
        required: false,
        options: [],
      },

      ...fields ];
    updateField(newFields);      
    this.setState({
      toggledEditor,
    });
  }

  onSort(fields) {
    const { updateField } = this.props;
    updateField(fields);
  }
  
  removeFieldItem(index) {
    const { updateField } = this.props;    
    confirm(__('Are you sure you want to remove the field?', locale), __('Remove Field', locale)).then(()=>{
        let fields = this.props.fields;
        const toggledEditor = {};
        let newFields = fields.slice(0)
        newFields.splice(index, 1);
        updateField(newFields);
        this.setState({
          toggledEditor,
        });
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  toggleFieldItemEditor(index) {
    let toggledEditor = this.state.toggledEditor;

    if (!toggledEditor[index]) {
      toggledEditor[index] = true;
    } else {
      toggledEditor[index] = false;
    }

    this.setState({
      toggledEditor,
    });
  }

  onDragStart(index) {

    return ()=>{
      let { toggledEditor } = this.state;

      let editorStateBeforeDragged = toggledEditor[index];

      toggledEditor[index] = false;

      this.setState({
        draggableIndex: index,
        editorStateBeforeDragged,
      });
    }

  }
  onDragEnd() {
    this.setState({
      draggableIndex: -1,
    });
  }
  saveField(index) {
    const { saveField } = this.props;
    saveField();
    this.toggleFieldItemEditor(index);
  }
  render() {
    const { isSortable, fetching, fields, onChange } = this.props;
    const { toggledEditor, draggableIndex } = this.state;
    const items = map(fields, (field, index)=>{
      const { label, type, options, required, } = field || {};
        return (
          <FieldItem
             key={index}
             sortId={index}
             index={index}
             items={fields}
             label={label}
             type={type}
             options={options}
             required={required}
             editable={true}
             onChange={onChange}
             onSortItems={this.onSort}
             isSortable={isSortable}
             draggable={index === draggableIndex}
             onMouseDownOnBars={this.onDragStart(index)}
             onDragEnd={this.onDragEnd}
             saveField={()=>this.saveField(index)}
             onRemove={()=>{
               this.removeFieldItem(index);
             }}
             toggleEdit={()=>{
               this.toggleFieldItemEditor(index)
             }}
             isEditing={toggledEditor[index]}
           />
       )
     });

    return (
      <Panel
        title={__('Other Info', locale)}
        titleContent={<button disabled={fetching} onClick={this.addFieldItem} className='btn-sm btn-primary'>{__('Add New', locale)}</button>}
      >
        <ul className='other-info sortable-list'>
          {fetching && <Loading />}
          {!fetching && items}
        </ul>
      </Panel>
    )
  }
}

export default CustomField;



// WEBPACK FOOTER //
// ./src/components/UI/CustomField/index.js